import {
  useEffect,
  useMemo,
  useState
} from 'react';
import useDevicesStore from 'store/devices';
import ListItem from './list-item';

const INITIAL_CHUNK_SIZE = 200;
const CHUNK_SIZE = 200;
const CHUNK_DELAY_MS = 16;


function List({devices=[], path=[], showChildren=true}) {
  const [devicesStore] = useDevicesStore();
  const [visibleCount, setVisibleCount] = useState(INITIAL_CHUNK_SIZE);

  useEffect(() => {
    setVisibleCount(Math.min(INITIAL_CHUNK_SIZE, devices.length));
  }, [devices.length]);

  useEffect(() => {
    if (visibleCount >= devices.length) {
      return;
    }

    const timer = setTimeout(() => {
      setVisibleCount((count) => Math.min(count + CHUNK_SIZE, devices.length));
    }, CHUNK_DELAY_MS);

    return () => clearTimeout(timer);
  }, [visibleCount, devices.length]);

  const visibleDevices = useMemo(() => {
    return devices.slice(0, visibleCount);
  }, [devices, visibleCount]);

  return (<ul>
    {visibleDevices.map((device) => {
      return (
        <ListItem
          device={devicesStore.shallowDevices.get(device.id) || {model: device}}
          key={device.id}
          path={path}
          showChildren={showChildren}
        />
      );
    })}
  </ul>);
}

export default List;
